import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

// Hook to check if a campaign has associated posts
export function useCheckCampaignPosts() {
    const query = useMutation({
        mutationFn: async (campaignId: number) => {
            try {
                // Check if there are posts associated with this campaign
                const response = await loggedInApiCall.get(`/api/ssq-posts?campaign=${campaignId}&itemsPerPage=1`);

                return {
                    hasPosts: response.data["hydra:totalItems"] > 0,
                    totalPosts: response.data["hydra:totalItems"],
                };
            } catch {
                // If we can't check, assume it's safe to proceed
                return { hasPosts: false, totalPosts: 0 };
            }
        },
    });

    return query;
}
